import { Component, Input, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';
import { WarehouseInventoryv2Constant } from './report-warehouse-inventory-v2.constants';
import { UnitTypeEnum } from '../../models/unit-type-enum';
import { WarehouseInventoryv2MenuEnum } from './report-warehouse-inventory-v2.enum';
import { SharedService } from 'src/app/common/services/shared.service';
import { WarehouseInventoryv2Service } from './report-warehouse-inventory-v2.service';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { TranslateService } from '@ngx-translate/core';
import { StoreService } from 'src/app/common/services/store.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { ReportsChartEnum } from 'src/app/reports/models/enums/reports.enum';
import { Subject, takeUntil } from 'rxjs';
import moment from 'moment';
import { ReportTableDropdown } from '../../models/reports.model';

@Component({
  selector: 'app-report-warehouse-inventory-v2',
  templateUrl: './report-warehouse-inventory-v2.component.html',
  styleUrls: ['./report-warehouse-inventory-v2.component.scss']
})
export class ReportWarehouseInventoryV2Component {

  RYDCHECK = environment.RYDCHECK;
  @Input() params: any;
  UnitTypeEnum = UnitTypeEnum;
  overViewMenu = WarehouseInventoryv2Constant.overViewMenu;
  currentScroll: any = '';
  WarehouseInventoryv2MenuEnum = WarehouseInventoryv2MenuEnum;
  chartView = ReportsChartEnum;

  placeName = '';
  userInfo: any = 0;
  placeCode: string = '';
  CurrencyCode: string = '';
  propertyInfo: any = {};
  isFirstTime = true;
  overViewLoading: boolean = true;
  overViewSummary: any = null;
  overViewSubCategory: any = null;

  currentPageIndex: number = 0;

  overviewbuiltUpArea: any[] = [];
  overviewTotalLandCovered: any[] = [];
  overviewTotalWarehouse: any[] = [];
  overViewCategory: any = null;
  grossBuiltupChartLoading = false;
  langName: any;
  isChart = true;


  houserentalChartLoading: boolean = false;
  houserentalChart: any = [];


  warehouserentChartLoading = false;
  
  selectedChartValue: any[] = [];
  wharehouserentChartReport: any[] = [];
  warehouseRentrateReport: any = null;
  
  graphLoader: boolean = false;

  downloadLoading: any = {
    a: false,
    b: false,
    c: false,
    d: false
  };
  sqm_unit: string = '';

  UnitSizeWiseCount=0;
  projectCount=0;

  tableName:unknown;
   private destroy$ = new Subject<void>();
  moreText: any;
  warehouseUnitsizedata: any[] = [];
  warehouseUnitsizeLoading: boolean = false;
  retailUnitsizeCount: number=0;

  warehouseUnitsizeColumns = WarehouseInventoryv2Constant.warehouseUnitsizeColumns;
  unitSizeDropdown = WarehouseInventoryv2Constant.unitSizeDropdown;

  projectLoading: boolean=false;
  inventoryProjectColumns = WarehouseInventoryv2Constant.inventoryProjectColumns;
  warehouseProjectdata: any;
  
  landpricedataLoading:boolean=true;
  inventoryLandPriceColumns = WarehouseInventoryv2Constant.inventoryLandPriceColumns
  landpricedata: any = [];
  landpriceCount: number = 0;
  landpriceActualCount : number = 0;
  landpriceEstimatedCount : number = 0;
  landpriceAuctionCount : number = 0;

  inventorypropertyTransaColumns = WarehouseInventoryv2Constant.inventoryPropertyTransactionColumns;

  propertyTransactiondataLoading: boolean = false;
  propertyTransactiondata: any = [];
  propertyTransactionCount: number = 0;
  propertyTransactionActualCount : number = 0;
  propertyTransactionEstimatedCount : number = 0;
  propertyTransactionAuctionCount : number = 0;
  transTypes: any;
  transTypes1: any;

    transactionType: ReportTableDropdown = {
        label: "reports.transactionType",
        data: [{
          value: 'Actual',
          id: 'Actual'
        }, {
          value: 'Auction',
          id: 'Auction'
        }, {
          value: 'Quote',
          id: 'Quote'
        }],
        default: "Actual",
        maxSelect: 3,
        reportType: true
    }

  resetPaginator: boolean = false;
  resetPaginator1: boolean = false;

  overviewAverageRateLoading:boolean = false;
  overViewAverageSummary: any = {};
  overviewAverageRate: any[] = [];

  overViewRentalYieldLoading: boolean =false;
  overViewRentalYieldSummary: any;
  overviewRentalYieldRate: any[] = [];

selected_chart_alltype ='Cumulative';
selected_chart_category = 'Cumulative';

developerDropdown = {
        label: 'reports.Select_type_of_property',
        data: [
        {
            value: 'Cumulative',
            id: 'Cumulative',
        },
        {
            value: 'Incremental',
            id: 'Incremental',
        }
      ],
        default: 'Cumulative',
        maxSelect: 1,
        reportType: false
    }
  alltypeLoading: boolean = false;
  categoryChartLoading: boolean = false;

  allTypeChart: any =  [];
  allTypeWaterfallChart:any=[];
  
  categoryChart: any =  [];
  categoryWaterfallChart:any=[];
  keyOrder: any;

  gradeProperties=0;
  rentalYieldProperties=0;
  zoningList:string='Zoning Covered';
  constructor(
    public sharedService: SharedService,
    private warehouseInventoryv2Service: WarehouseInventoryv2Service,
    private alertService: AlertService,
    public reportService: ReportService,
    public translate: TranslateService,
    private storeService: StoreService
  ) {
    this.sqm_unit = 'reports.' + GlobalContants.keySymbolContants.squareMeterUnit;
    this.sharedService.language$.subscribe(lang => {
      this.langName = lang;
      if (lang && !this.isFirstTime) {
        this.getReports();
        this.isChart = false;
      }
    })
    if (sharedService.priceCalculation$() === this.sharedService.priceYearly) {
      this.overViewMenu[1]['label'] = 'reports.annualRentUnitSizeWise';
      this.inventoryProjectColumns[5]['columnName']='reports.annual_lease_rate'
    }
  }

  lastClickedTable(event:Event, table:any){
    this.tableName = table
  }
  ngOnInit() {
    this.transTypes = this.transactionType.data.map(e=> {return e.id});
    this.transTypes1 = this.transactionType.data.map(e=> {return e.id});
    this.getReports();
    this.isFirstTime = false;
    this.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
    this.CurrencyCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode);
    this.placeName = this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceName);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['params'] && changes['params'].currentValue && !changes['params'].firstChange) {
      this.warehouseInventoryv2Service.projectsPayload.pageNumber = 0;
      this.warehouseInventoryv2Service.landPricesPayload.pageNumber = 0;
      this.warehouseInventoryv2Service.propertyTransactionPayload.pageNumber = 0;
      this.propertyInfo = null;

      this.projectCount=0;
      this.transTypes = this.transactionType.data.map(e=> {return e.id});
      this.transTypes1 = this.transactionType.data.map(e=> {return e.id});
      this.getReports();
    }
  }

  getReports() {
    this.destroy$.next();
    this.getOverviewSummary1();
    this.getChartsDataBuiltup('builtup');
    this.getChartsDataVacant('vacant');

    this.getOverviewSummaryAverageRentRate();
    this.getOverviewSummaryRentalYield();
    this.getGrossBuiltupChart();
    this.getRentUnitSizeWise();
    this.getProjects();
    this.getLandprices(this.transTypes.toString());
    this.getPropertyTransaction(this.transTypes1.toString());
  }

  /**
     * Rent Rate Graph API
     */
    getGrossBuiltupChart() {
      this.warehouserentChartLoading = true;
      this.warehouseInventoryv2Service.getWarehouseRentRateReport()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (res: any) => {
              this.warehouserentChartLoading = false;
              if (res.status === 200) {
                let data = {...res.data};
              
                let sortkeys = ['All Categories', 'Dry Warehouse', 'Ambient', 'Cold Storage', 'Frozen Warehouse']
                this.keyOrder = (a: any, b: any): number => {
                    return sortkeys.indexOf(a.key) - sortkeys.indexOf(b.key);
                  };
                if(this.langName === 'ar' ){
                    sortkeys = ["الكل فئات", "مخزن بضائع جافة", "غير مكيف", "مخزن مُبرد", "مخزن مجمد"]
                }
                let ordered:  Record<string, any> = {};
                sortkeys.map((e: string) => {
                  if (data[e]) {
                    ordered[e] = data[e];
                  }
                })
                this.warehouseRentrateReport = ordered;
                this.selectedChartValue = Object.keys(this.warehouseRentrateReport).slice(0, 3);

                //transform the data
                Object.keys(this.warehouseRentrateReport).forEach((key, index) => {
                  let data = this.warehouseRentrateReport[key];
                  this.warehouseRentrateReport[key] = data.map((obj: any) => ({
                    category: String(obj.year),
                    value: obj.count,
                    name: key
                  }));
                });
  
                // Update the retail rental chart report
                this.wharehouserentChartReport = Object.keys(this.warehouseRentrateReport)
                  .filter(key => this.selectedChartValue.includes(key))
                  .reduce((obj: any, key: any) => {
                    obj[key] = this.warehouseRentrateReport[key];
                    return obj;
                  }, {});
                  setTimeout(() => this.moreText = this.reportService.optionsCountDropdown(this.selectedChartValue));
              } else {
                this.warehouseRentrateReport = null;
                this.wharehouserentChartReport = [];
                this.selectedChartValue = [];
              }
  
            },
            error: (error: any) => {
              this.warehouseRentrateReport = null;
              this.warehouserentChartLoading = false;
              this.wharehouserentChartReport = [];
              this.selectedChartValue = [];
            }
  
          }
        );
    }

    selectChart(e: any, value: any) {

    let index = this.selectedChartValue.indexOf(value)
    if (!e.checked) {
      if (this.selectedChartValue.length === 1) {
        this.alertService.warn(this.translate.instant('atLeastOneMust'));
        e.source.checked = true;
      } else {
        this.selectedChartValue.splice(index, 1);
      }
    } else {
      if (this.selectedChartValue.length > 2) {
        this.alertService.warn(this.translate.instant('youCannotSelectMoreThan'));
        e.source.checked = false;
        return;
      } else {
        this.selectedChartValue.push(value)
      }
    }

    this.wharehouserentChartReport = Object.keys(this.warehouseRentrateReport)
      .filter(key => this.selectedChartValue.includes(key))
      .reduce((obj: any, key: any) => {
        obj[key] = this.warehouseRentrateReport[key];
        return obj;
      }, {});
    // this.wharehouserentChartReport = this.sharedService.sortObjectByKey(this.wharehouserentChartReport);
    this.wharehouserentChartReport = this.wharehouserentChartReport;
    this.warehouserentChartLoading = false;
    setTimeout(() => this.moreText = this.reportService.optionsCountDropdown(this.selectedChartValue));
  }

  getReportKeys(): string[] {
    if (this.warehouseRentrateReport) {
      return Object.keys(this.warehouseRentrateReport);
    }
    return [];
  }
    
  getOverviewSummary1() {
    this.overViewLoading = true;
      this.warehouseInventoryv2Service.getOverviewDataInventoryV2().pipe(takeUntil(this.destroy$)).subscribe({
        next:(res:any)=>{
          if(res.status == 200){
           this.overViewSummary = res.data;
           if(this.overViewSummary?.total_area?.as_of_date) this.overViewSummary.total_area['untillDate'] = moment.utc(this.overViewSummary.total_area.as_of_date).local().format('DD MMM YYYY');
           if(this.overViewSummary?.total_properties?.as_of_date) this.overViewSummary.total_properties['untillDate'] = moment.utc(this.overViewSummary.total_properties.as_of_date).local().format('DD MMM YYYY');
           this.overViewLoading = false;
          } else {
            this.overViewSummary=null;
          }
        },error:(err)=>{
          this.overViewSummary=null;
        }
      })
  }
  

   getOverviewSummaryAverageRentRate() {
     this.overviewAverageRateLoading = true;
     this.warehouseInventoryv2Service.getOverviewSummary()
       .pipe(takeUntil(this.destroy$)) // Unsubscribe when destroy$ emits
       .subscribe(
         {
           next: (res: any) => {
             if (res.status === 200) {
               this.overViewAverageSummary = res.data;
               this.overViewAverageSummary['untillDate'] = moment.utc(this.overViewAverageSummary.as_of_date).local().format('DD MMM YYYY');
               this.overviewAverageRate = this.overViewAverageSummary?.average_rate || [];
               this.gradeProperties = this.overViewAverageSummary?.total_properties || this.overviewAverageRate.reduce(
                  (s: number, a: any) => s + Number(a.count || 0), 
                  0
                )
             } else {
               this.overViewAverageSummary = {};
               this.overviewAverageRate = [];
               this.gradeProperties=0
             }
             this.overviewAverageRateLoading = false;
           },
           error: (error: any) => {
             this.overViewAverageSummary = {};
             this.overviewAverageRate = [];
             this.overviewAverageRateLoading = false;
             this.gradeProperties=0
           }
         }
       )
   }


  getOverviewSummaryRentalYield() {
      this.overViewRentalYieldLoading = true;
      this.warehouseInventoryv2Service.getOverviewSummaryrentalYield()
        .pipe(takeUntil(this.destroy$)) // Unsubscribe when destroy$ emits
        .subscribe(
          {
            next: (res: any) => {
              if (res.status === 200 && res.data?.data?.length) {
                let resData = res.data;
                this.overViewRentalYieldSummary = resData;
                this.overViewRentalYieldSummary['untillDate'] =  moment.utc(this.overViewRentalYieldSummary.as_of_date).local().format('DD MMM YYYY');
                this.rentalYieldProperties = resData?.count || this.overViewRentalYieldSummary?.data.reduce((sum:number, item:any) => sum + item.property_count, 0);
              } else {
                this.overViewRentalYieldSummary = null;
                this.rentalYieldProperties = 0;
              }
              this.overViewRentalYieldLoading = false;
            },
            error: (error: any) => {
              this.overViewRentalYieldSummary = null;
              this.overViewRentalYieldLoading = false;
              this.rentalYieldProperties = 0;
            }
          }
        )
   }

   
  getChartsDataBuiltup(type: string = '') {
    this.alltypeLoading =true;
    this.warehouseInventoryv2Service.getChartsDataBarAndWater(type).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        this.alltypeLoading = false;
        if (res.status == 200) {
          this.allTypeChart = res.data
           .filter((element: any) => element.cumulative_builtup != null && element.cumulative_builtup !== 0)
           .map((element: any) => ({
            category: element.year.toString(),
            value: element.cumulative_builtup
          }));

          this.allTypeWaterfallChart = res.data
          .filter((element: any) => element.incremental_builtup != null && element.incremental_builtup !== 0)
          .map((element: any) => ({
            year: element.year.toString(),
            rate: element.incremental_builtup
          }));
          
        } else {
          this.allTypeChart = [];
          this.allTypeWaterfallChart = [];
        }
      }, error: (err) => {
        this.alltypeLoading = false;
        this.allTypeChart = [];
        this.allTypeWaterfallChart = [];

      }
    })

  }

  getChartsDataVacant(type: string = '') {
    this.categoryChartLoading = true;
    this.warehouseInventoryv2Service.getChartsDataBarAndWater(type).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        this.categoryChartLoading = false;
        if (res.status == 200) {
          this.zoningList = 'Zoning Covered';
          this.zoningList += (res.data.zoning?.length ? ` - ${res.data.zoning?.join(', ')}`:'');
          this.categoryChart = res.data.data
          .filter((element: any) => element.cumulative_vacant != null && element.cumulative_vacant !== 0)
          .map((element: any) => ({
            category: element.year.toString(),
            value: element.cumulative_vacant
          }));

          this.categoryWaterfallChart = res.data.data
          .filter((element: any) => element.incremental_vacant != null && element.incremental_vacant !== 0)
          .map((element: any) => ({
            year: element.year.toString(),
            rate: element.incremental_vacant
          }));
        } else {
          this.zoningList ='';
          this.categoryChart = [];
          this.categoryWaterfallChart = []
        }
      }, error: (err) => {
        this.zoningList ='';
        this.categoryChartLoading = false;
        this.categoryChart = [];
        this.categoryWaterfallChart = []
      }
    })
  }

  getRentUnitSizeWise(){
    this.warehouseUnitsizeLoading = true;
    this.warehouseInventoryv2Service.getWarehouseUnitSize(this.warehouseInventoryv2Service.warehouseUnitSizePayload)
      .pipe(takeUntil(this.destroy$)) // Unsubscribe when destroy$ emits
      .subscribe(
        {
          next: (res: any) => {
            if (res.status === 200) {
              if (res.data) {
                this.UnitSizeWiseCount = res.count;
                let cols = [
                  'ambient_range',
                  'air_conditioned_range',
                  'frozen_chiller_range',
                  'open_yard_range',
                ]

                res.data.map((el: any) => {
                  Object.keys(el).map((e: any) => {
                    if (cols.includes(e)) {
                      el[e] = this.reportService.rangeToNumberFor(el[e]);
                    }
                    if (el.details && el.details.length > 0) {
                      el.details.map((detail: any) => {
                        Object.keys(detail).map((key: any) => {
                          if (cols.includes(key)) {
                            detail[key] = this.reportService.rangeToNumberFor(detail[key]);
                          }
                        })
                      })
                    }
                  })
                })
              }
              this.warehouseUnitsizedata = this.reportService.setTableDataSource(res.data);
              // if (this.warehouseInventoryv2Service.warehouseUnitSizePayload.pageNumber == 0) {
              //   this.retailUnitsizeCount = res.count;
              // }

            } else {
              this.warehouseUnitsizedata = [];
              this.retailUnitsizeCount = 0;
            }
            this.warehouseUnitsizeLoading = false;
          },
          error: (error: any) => {
            this.warehouseUnitsizedata = [];
            this.retailUnitsizeCount = 0;
            this.warehouseUnitsizeLoading = false;
          }

        }
      )
  }

  getProjects(){
      this.projectLoading = true;
    this.warehouseInventoryv2Service.getwarehouseInventProjects(this.warehouseInventoryv2Service.projectsPayload)
      .pipe(takeUntil(this.destroy$)) // Unsubscribe when destroy$ emits
      .subscribe(
        {
          next: (res: any) => {
            if (res.status === 200) {
              this.warehouseProjectdata = this.reportService.setTableDataSource(res.data);
              if (this.warehouseInventoryv2Service.projectsPayload.pageNumber == 0) {
                this.projectCount = res.count;
              }

            } else {
              this.warehouseProjectdata = [];
              this.projectCount = 0;
            }
            this.projectLoading = false;
          },
          error: (error: any) => {
            this.warehouseProjectdata = [];
            this.projectCount = 0;
            this.projectLoading = false;
          }

        }
      )
  }
  

  getLandprices(type:string=''){
    this.landpricedataLoading = true;
    this.warehouseInventoryv2Service.getLandprices(this.warehouseInventoryv2Service.landPricesPayload, type).pipe(takeUntil(this.destroy$)).subscribe(
      {next:(res: any) => {

        if(res.status === 200){
          let data = res.data.map((value: any) => {
            //if source type so transaction_type concat with source_type
            if(value?.source_type) value['transaction_type'] = value['transaction_type'] + ` (${value?.source_type})`;
            value['value'] = this.reportType(value);
            value['transaction_date']= value.transaction_date ? moment.utc(value.transaction_date).local().format('DD MMM YYYY') : null;
            if(value?.details) {
              for(let i = 0; i < value?.details.length; i++) {
                value.details[i]['transaction_date'] = value?.details[i]?.transaction_date ? moment.utc(value.details[i].transaction_date).local().format('DD MMM YYYY') : null
                value.details[i]['value'] = this.reportType(value.details[i]);
                //if source type so transaction_type concat with source_type
                if(value.details[i]?.source_type) value.details[i]['transaction_type'] = (value.details[i]['transaction_type'] + ` (${value.details[i]?.source_type})`);
              }
            }
            if(value.lat && value.lon){
              value.centroid = {
                coordinates: [value.lon, value.lat]
              }
            }
            return value;
          });
          this.landpricedata = this.reportService.setTableDataSource(data);
         if(this.warehouseInventoryv2Service.landPricesPayload.pageNumber == 0){
          this.landpriceCount = res.count;
          this.landpriceActualCount = res.actual_count;
          this.landpriceEstimatedCount = res.estimate_quote_count;
          this.landpriceAuctionCount = res.auction_count || 0
         }
        } else {
          this.landpricedata = [];
          this.landpriceCount = 0;
          this.landpriceActualCount = 0;
          this.landpriceEstimatedCount = 0;
          this.landpriceAuctionCount = 0;
        }
        this.landpricedataLoading = false;
      },
      error: (error:any) => {
        this.landpricedata = [];
        this.landpriceCount = 0;
        this.landpriceActualCount = 0;
        this.landpriceEstimatedCount = 0;
        this.landpriceAuctionCount = 0;
        this.landpricedataLoading = false;
      }}
    )
  }

  getPropertyTransaction(type:string = ''){
    this.propertyTransactiondataLoading = true;
    this.warehouseInventoryv2Service.getPropertyTransaction(this.warehouseInventoryv2Service.propertyTransactionPayload, type)
    .pipe(takeUntil(this.destroy$)).subscribe(
      {next:(res: any) => {

        if(res.status === 200){
          let data = res.data.map((value: any) => {
            //if source type so transaction_type concat with source_type
            if(value?.source_type) value['transaction_type'] = value['transaction_type'] + ` (${value?.source_type})`;
            value['value'] = this.reportType(value);
            value['transaction_date']= value.transaction_date ? moment.utc(value.transaction_date).local().format('DD MMM YYYY') : null;
            if(value?.details) {
              let dedata:any = value?.details.filter((e:any) => !e.is_latest);
              value['details'] = dedata;
              for(let i = 0; i < value?.details.length; i++) {
                value.details[i]['transaction_date'] = value?.details[i]?.transaction_date ? moment.utc(value.details[i].transaction_date).local().format('DD MMM YYYY') : null
                value.details[i]['value'] = this.reportType(value.details[i]);
                //if source type so transaction_type concat with source_type
                if(value.details[i]?.source_type) value.details[i]['transaction_type'] = (value.details[i]['transaction_type'] + ` (${value.details[i]?.source_type})`);
              }
            }
            if(value.lat && value.lon){
              value.centroid = {
                coordinates: [value.lon, value.lat]
              }
            }
            return value;
          });
          this.propertyTransactiondata = this.reportService.setTableDataSource(data);
          
         if(this.warehouseInventoryv2Service.propertyTransactionPayload.pageNumber == 0){
          this.propertyTransactionCount = res.count;
          this.propertyTransactionActualCount = res.actual_count;
          this.propertyTransactionEstimatedCount = res.estimate_quote_count;
          this.propertyTransactionAuctionCount = res.auction_count || 0
         }
        } else {
          this.propertyTransactiondata = [];
          this.propertyTransactionCount = 0;
          this.propertyTransactionActualCount = 0;
          this.propertyTransactionEstimatedCount = 0;
          this.propertyTransactionAuctionCount = 0;
        }
        this.propertyTransactiondataLoading = false;
      },
      error: (error:any) => {
        this.propertyTransactiondata = [];
        this.propertyTransactionCount = 0;
        this.propertyTransactionActualCount = 0;
        this.propertyTransactionEstimatedCount = 0;
        this.propertyTransactionAuctionCount = 0;
        this.propertyTransactiondataLoading = false;
      }}
    )
  }

  barSortData(data: any) {
    let overviewArray: any = Object.entries(data);
    return overviewArray.sort((a: any, b: any) => b[1].category - a[1].category);
  }



  downloadExcel(event: any, type: string, key: any, module_name:any='warehouse_details') {
    this.downloadRentalReport(type, key, module_name);
  }

  downloadRentalReport(type: string, key: any, module_name:any) {
    this.downloadLoading[key] = true;
    let price_type= '';
    if(type == 'warehouse_details_land_price_transaction'){
      price_type = this.transTypes;
    }else if(type == 'warehouse_details_building_price_transaction'){
       price_type = this.transTypes1
    }
    this.reportService.downloadReport(type, this.userInfo?.user_id, '', '', false, '', price_type).subscribe(
      {
        next: (res: any) => {
          this.downloadLoading[key] = false;
          if (res.status === 200) {
            const downloadUrl = `${this.sharedService.downloadExcelPath()}?file_name=${res.data}&city_code=${this.placeCode.toLowerCase()}&module_name=${module_name}`;
            this.sharedService.downloadExcelUrl(downloadUrl);
            this.alertService.success(this.translate.instant('reports.downloadRequestSubmitted'));

          } else {
            this.alertService.warn(res.message)
          }
        },
        error: (error: any) => {
          this.downloadLoading[key] = false;
        }
      }
    )
  }

  onPageEvent(e: any, report: any) {
    if (e.previousPageIndex !== e.pageIndex) {
      if (report === this.WarehouseInventoryv2MenuEnum.project) {
        this.warehouseInventoryv2Service.projectsPayload.pageNumber = (e.pageSize * e.pageIndex);
        this.getProjects();
      }else if (report === this.WarehouseInventoryv2MenuEnum.landprices) {
        this.warehouseInventoryv2Service.landPricesPayload.pageNumber = (e.pageSize * e.pageIndex);
        this.getLandprices(this.transTypes.toString());
      }else if (report === this.WarehouseInventoryv2MenuEnum.propertyTransaction) {
        this.warehouseInventoryv2Service.propertyTransactionPayload.pageNumber = (e.pageSize * e.pageIndex);
        this.getPropertyTransaction(this.transTypes1.toString());
      } 
    }

  }

  menuChangeValue(menu: any) {
    this.currentScroll = menu.name;
    setTimeout(() => {
      this.scrollPoint(menu.name);
    })
  }

  scrollPoint(menu: string) {
    this.sharedService.scrollMenu(menu);
  }

  selectionChange(value: any, type: number) {
    
    if (type == WarehouseInventoryv2MenuEnum.landprices) {
      this.transTypes = value.toString();
      this.warehouseInventoryv2Service.landPricesPayload.pageNumber = 0;
      this.resetPaginator = false; // force change detection
      setTimeout(() => {
        this.resetPaginator = true;
      }, 0);
      this.getLandprices(value.toString());
    } else if (type == WarehouseInventoryv2MenuEnum.propertyTransaction) {
       this.transTypes1 = value.toString();
      this.warehouseInventoryv2Service.propertyTransactionPayload.pageNumber = 0;
      this.resetPaginator1 = false; // force change detection
      setTimeout(() => {
        this.resetPaginator1 = true;
      }, 0);
      this.getPropertyTransaction(value.toString());
    }

  }

  dropDownChange(event :any, type:string){
    if(type == 'all_type'){
      this.selected_chart_alltype  = event;
    }else if(type == 'category'){
      this.selected_chart_category  = event;
    }
  }


   reportType(value: any): string {
      let recordType = `<div class="reportType-value">${value.value ? this.reportService.numFormat(value.value): ''}</div>`;
      if (value?.prop_type_govt && value?.prop_type_estater && value?.prop_type_govt !== value?.prop_type_estater) {
        recordType += `<div class="reportType-land"><del>${this.translate.instant(value?.prop_type_govt)}</del><span class='reportType'>*${this.translate.instant(value?.prop_type_estater)}</span></div>`;
      } else if (value?.prop_type_govt) {
        recordType += `<div  class="reportType-land">${this.translate.instant(value?.prop_type_govt)}</div>`;
      } else if (value?.prop_type_estater) {
        recordType += `<div  class="reportType-land">${this.translate.instant(value?.prop_type_estater)}</div>`;
      }
      return recordType;
    }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
